import { Pipe, PipeTransform } from '@angular/core';

const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

@Pipe({
  name: 'filesize'
})
export class FormatFileSizePipe implements PipeTransform {
  transform(sizeInBytes: number | null | undefined): string {
    // A missing/invalid size (e.g. a row from a server response that hasn't
    // populated it yet) must render as nothing, not "NaN undefined" -
    // Math.log(undefined/negative) is NaN, which then poisons every
    // downstream calculation including the units[] lookup.
    if (sizeInBytes == null || !Number.isFinite(sizeInBytes) || sizeInBytes < 0) {
      return '';
    }
    if (sizeInBytes === 0) {
      return `0 ${FILE_SIZE_UNITS[0]}`;
    }

    const units = FILE_SIZE_UNITS;

    let power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
    power = Math.min(power, units.length - 1);
    power = Math.max(power, 0);

    const size = sizeInBytes / Math.pow(1024, power); // size in new units
    const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
    const unit = units[power];

    return `${formattedSize} ${unit}`;
  }
}
